// @flow
import React, { Component } from 'react';
import { Spinner } from 'shared/globals';
import GlobalSideNav from '../../components/GlobalSideNav';
import GlobalTopNav from '../../components/GlobalTopNav';
import { AppMainSection } from './style';

export function LoadingFallback({ error }: { error: any }) {
  if (error) {
    // our ErrorBoundary will catch this
    throw error;
  }
  return <Spinner />;
}

class Application extends Component {
  state = {
    loading: true
  };

  componentDidMount() {
    if (
      window.localStorage.getItem('auth-token') === null ||
      window.localStorage.getItem('active-account') === null
    ) {
      window.location.href = '/admin';
    } else {
      if (this.props.orgId) {
        window.localStorage.setItem('active-account', this.props.orgId);
      }

      this.setState({
        loading: false
      });
      if (!this.props.user) this.props.getCurrentUser();
      if (!this.props.currentAccount) this.props.getCurrentUserAccounts();
      if (!this.props.currentAccountMeta) this.props.getCurrentUserAccountsMeta();
    }
    // window.freshworksOmnibar = {
    //   onSessionStateChanged: function callback() {
    //     console.log('#### freshid got disconnected ####');
    //     localStorage.clear();
    //     window.location.href = '/admin';
    //   }
    // };
  }

  render() {
    const { uri, user, children } = this.props;
    return this.state.loading ? (
      <LoadingFallback />
    ) : (
      <React.Fragment>
        <GlobalSideNav user={user} uri={uri} />
        <GlobalTopNav {...this.props} />
        <AppMainSection>{children}</AppMainSection>
      </React.Fragment>
    );
  }
}

export default Application;
